// ============================================================================
// THE NINE QUESTIONS FRAMEWORK - From "Prove It" by Erik Postnieks
// FFIEC BSA/AML Examination Manual, 12 CFR 21.21 compliance
// Four Data Primitives + Four Extensions + Operational Pillar (Training)
// ============================================================================

export const NINE_QUESTIONS = [
  {
    number: 1,
    key: 'who',
    label: 'WHO',
    question: 'Who owns this decision and is accountable for its defense?',
    placeholder: 'Jane Smith, BSA Officer',
    helpText: 'Per 12 CFR 21.21(d)(3): competence, authority, independence, and access to resources.',
    fields: ['owner_id', 'owner_email', 'who_competence', 'who_authority', 'who_independence', 'who_resources'],
    required: true,
  },
  {
    number: 2,
    key: 'what',
    label: 'WHAT',
    question: 'What is the specific policy, threshold, or scenario being documented?',
    placeholder: 'Wire transfer structuring detection threshold: $3,000',
    helpText: 'Per FFIEC BSA/AML Examination Manual, Risk Assessment and Transaction Monitoring: tailored to your institution\'s specific risk profile.',
    fields: ['name', 'description', 'what_risk_profile_alignment', 'what_reasonableness'],
    required: true,
  },
  {
    number: 3,
    key: 'when',
    label: 'WHEN',
    question: 'When was this established and when does it take effect?',
    placeholder: 'Established: 2024-01-15, Effective: 2024-02-01',
    helpText: 'Per FFIEC BSA/AML Examination Manual, Transaction Monitoring and Independent Testing: monitoring frequency and escalation timeframes.',
    fields: ['created_at', 'valid_from', 'when_monitoring_frequency', 'when_escalation_hours'],
    required: true,
  },
  {
    number: 4,
    key: 'why',
    label: 'WHY',
    question: 'Why is this the right value—what rationale and alternatives were considered?',
    placeholder: 'Based on FinCEN analysis showing 87% of structuring between $3K-$9.5K. $5K alternative rejected due to 34% detection gap.',
    helpText: 'Per FFIEC BSA/AML Examination Manual, Core Examination—Model Validation and Methodology: methodology selection and validation evidence.',
    fields: ['regulatory_basis', 'alternatives_considered', 'why_validation_evidence'],
    required: true,
    minLength: 50,
  },
  {
    number: 5,
    key: 'where',
    label: 'WHERE',
    question: 'Where is the supporting documentation located?',
    placeholder: 'https://steadfastly.ai/docs/SCN-2024-0047',
    helpText: 'System of record. Authoritative source for this governance data.',
    fields: ['documentation_location'],
    required: true,
  },
  {
    number: 6,
    key: 'authority',
    label: 'AUTHORITY',
    question: 'Under what regulatory authority is this required?',
    placeholder: '31 CFR 1010.311, FinCEN Guidance FIN-2021-A001',
    helpText: 'Delegation chain, board resolution, policy reference.',
    fields: ['authority_citation'],
    required: true,
  },
  {
    number: 7,
    key: 'evidence',
    label: 'EVIDENCE',
    question: 'What evidence proves this is implemented, not just documented?',
    placeholder: 'Attached: Q4-2024-Effectiveness-Analysis.pdf, Validation-Report-Dec-2024.xlsx',
    helpText: 'Supporting documentation, analysis, third-party validations.',
    fields: ['evidence_attachments', 'evidence_summary'],
    required: true,
  },
  {
    number: 8,
    key: 'review',
    label: 'REVIEW',
    question: 'When is this scheduled for review to ensure it remains current?',
    placeholder: 'Annual review: 2025-01-15. Event-triggered if FinCEN issues new structuring guidance.',
    helpText: 'Scheduled review date, frequency, review owner. Stale governance is failed governance.',
    fields: ['next_review_date', 'review_frequency'],
    required: true,
  },
  {
    number: 9,
    key: 'training',
    label: 'TRAINING',
    question: 'Who needs training? What training? When delivered? How is comprehension verified?',
    placeholder: 'BSA Officer annual training on structuring scenarios. Quiz completion 98%. Last completed 2025-01-15.',
    helpText: 'Per 12 CFR 21.21(d)(4): Training is FFIEC Pillar 4—a required element of compliance programs.',
    fields: ['training_requirements'],
    required: true,
  },
];

// Grid layout: Four Data Primitives (1-4), Four Extensions (5-8), Operational Pillar (9)
export const NINE_QUESTIONS_GRID = {
  primitives: [1, 2, 3, 4],   // WHO, WHAT, WHEN, WHY
  extensions: [5, 6, 7, 8],   // WHERE, AUTHORITY, EVIDENCE, REVIEW
  pillar: 9,                   // TRAINING
  leftColumn: [1, 2, 3, 4],
  rightColumn: [5, 6, 7, 8],
  training: 9,
};
